import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'print-button',
  standalone: false,
  templateUrl: './print-button.component.html',
  styleUrl: './print-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintButtonComponent {
  public isLoading = input<boolean>(false);
}
